import { gql } from '@apollo/client';
import Fragments from './fragments';
import DictionaryFragments from '../list/fragments';

export const DICTIONARY_QUERY = gql`
  query dictionary($id: Int!) {
    dictionary(id: $id) {
      ...dictionary
    }
  }
  ${DictionaryFragments.dictionary}
`;

export const GENERIC_DICTIONARY_ITEMS_QUERY = gql`
  query genericDictionaryItems($dictionaryId: Int!) {
    genericDictionaryItems(dictionaryId: $dictionaryId) {
      ...genericDictionaryItem
    }
  }
  ${Fragments.dictionaryItem}
  ${Fragments.genericDictionaryItem}
`;

export const DICTIONARY_ITEMS_QUERY = gql`
  query dictionaryItems($dictionaryId: Int!) {
    dictionaryItems(dictionaryId: $dictionaryId) {
      ...dictionaryItem
    }
  }
  ${Fragments.dictionaryItem}
`;
